export const VERSION_APP = '1.0.2';
export const HOME_DIR = '/';
export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbwialw-LVrpoCedFiPc0Y3OY26T0nMHsaS_Hj8KxlFd1sH1wyC3eHV-Im78UZYF6GLS/exec',
        API_BASE_URL2: 'https://script.google.com/macros/s/AKfycbxBgOSSrZnkKtYqXysTKbjz7_GqCOFsUcAjF4khpbldwqCdm9b-ajcv7OW__5zBuK4uCA/exec',
        API_BASE_URL3: 'https://script.google.com/macros/s/AKfycbzlW3W4WvmLluAVRQJpLaaSO_fYdEOURfUgZjq1t1jVNyNIbvjibzE1e4YhAzv95RCxfg/exec',
        API_BASE_URL4: 'https://script.google.com/macros/s/AKfycbwX_hCumB9Ife3YOgBLmDRCQ9736htPWwhA9wAcWl4T4D9XP-VPT8VJrq1RxUnWrmo/exec',
        API_BASE_URL5: 'https://script.google.com/macros/s/AKfycbyloEm5IjJpCBdS8kiwJhpjWSj5EE1mzEPcHClhDpAzSb7wx28j6c9JcEOc4vDDNlQf/exec',
        API_BASE_URL6: 'https://script.google.com/macros/s/AKfycbzv-YXTDaau-JOFCerVUqu1_ZJpw9jIn1xUWqEJwoufFmn6N6muVFd-giStuYehOdmQ/exec',
        API_BASE_URL7: 'https://script.google.com/macros/s/AKfycbzEowK3fjhuu06q4YhQHu6PocedvadrI3GmJgPbD4sW4qIS_pIi7lOov_GHaY7Lkz_f/exec',
        API_BASE_URL8: 'https://script.google.com/macros/s/AKfycbwNPvQImnG-G-gMzg_IfomljW9Pjg3Zjls-BZxKqxuTbBTEJGskI4M9BBDqUwEF_CHMfA/exec',
        API_BASE_URL9: 'https://script.google.com/macros/s/AKfycbwVIV7eGiFOP04ov3dqKj7i_yRPvQs_C2j6lavqntgXcQkdfnQpntTsTSQ3Etjmeerf/exec',
        API_BASE_URL10: 'https://script.google.com/macros/s/AKfycbzFB5_cDMc_tOWzITnxTFeiX6kUTvCGMbiesyI15kk42e8KuJN8k-WV8-paycSAj5edJg/exec',
        API_BASE_URL11: 'https://script.google.com/macros/s/AKfycbz4K-CXQU3MMhXyBYjumYZXuJvCnmLGQRXBZsQ-A_IO1Qh3eyrOs8MMCVqDp5LVL7e1SA/exec',
        API_BASE_URL12: 'https://script.google.com/macros/s/AKfycbzP8THN8kviz-V3jhieK4YO18R7LUCoIQjxMKXTmsCUzYUaQiz7In4z2OFC25w10yZ2uw/exec',
        API_BASE_URL13: 'https://script.google.com/macros/s/AKfycbwxy90SXohUDv2j6kkY2kCD0ToaU5nBNUj4StTTr6acwwK1FK3z0vys-s3QQbx23gfKPw/exec',
        API_BASE_URL14: 'https://script.google.com/macros/s/AKfycbyCppWIGUwWOkSI3O-4JT2PCI2g5G1QkFgb8i2jJ42a2wP0d8jySeY-IDP7qrfbPdflQQ/exec',
        API_BASE_URL15: 'https://script.google.com/macros/s/AKfycbyQDGnh-hhTpzaI-sKxVERmSBfenhb0FvO1_UX3nZJ6WwXhR_zwjFJ7TgUsSTyWt_ag/exec',
        API_BASE_URL16: 'https://script.google.com/macros/s/AKfycbz1WWKCI6kAp2OI5soeVMDkSf7831oaYQmkiJVhR0OA84_wUEDZGnszo-c93QsRFOT8zg/exec',
        API_BASE_URL17: 'https://script.google.com/macros/s/AKfycbzsmGL2SsxWtAaXSxwrdFtxJOj_pa61H5kdysdoYDNRuhjbFY5zCPLxNNlShd_Jz1e2aQ/exec',
        API_BASE_URL18: 'https://script.google.com/macros/s/AKfycbyvdY7ipPJ7mP08CCngkKELfDWLM2j7BEeNZQ9I41S5vIPIczmZVWXT6At85-PsfXN7/exec',
        API_BASE_URL19: 'https://script.google.com/macros/s/AKfycby6B0jhy5FEdn5PveMFvXjgCpQGOsydGF5B81qfBmA7OyKBoPExsWe2IjFVw9I7lfE46A/exec',
        API_BASE_URL20: 'https://script.google.com/macros/s/AKfycbwg36sgGrLVFnuCuceC7_TOmMxaGf7hr9g5JUTsjvPPAoHO4u5qiGqZYxHpMxKkSc2T/exec',
        API_BASE_URL21: 'https://script.google.com/macros/s/AKfycbxCIyOAIwp4zysv5-abFzEA4-c93gGzPv520se6fauwo7D1hxVb9l7KLi9sLdPVXdF-/exec',
        API_BASE_URL22: 'https://script.google.com/macros/s/AKfycbxPUaynz-in2dgk7GDWfe1BP3seS6FBbFehlWDA9PBS8QRcfv_qxpFoU17b3aPW7RjCsQ/exec',
        API_BASE_URL23: 'https://script.google.com/macros/s/AKfycbwWJ9VcP7KmTLprKVfh6trxuj3LO0V-z4LuI_Dyy3mrCZz25jB9WPiClcqmZchyP5FM/exec',
        API_BASE_URL24: 'https://script.google.com/macros/s/AKfycbwSe6KqQCfBIjpy2gH3YKdHbZ_bRf9dlvllaO8JzmMLgGvfyu0cX7Ce-VmnSiaS9zcD/exec',
        API_BASE_URL25: 'https://script.google.com/macros/s/AKfycbwMDjFal2nLcrt6Qvo1jypdi_rEE4jNJulaZ5qsAJWmVIw8pczbJwvYetyM71YLIKNJvQ/exec',
        API_BASE_URL26: 'https://script.google.com/macros/s/AKfycbwy36rIp0M-uyTXbgpOKTdLFMOWiAjcWhQN9ww_ZJ57t-aEORUcsOFSStVYzHubNrVo/exec',
        API_BASE_URL27: 'https://script.google.com/macros/s/AKfycbwtx5BbjEPKzJEaEneRN6ha-ulLJaOiMiMhOKW-pz8XfwQNlaVb4Jx-GZF4wUNsjO8mQw/exec',
        API_BASE_URL28: 'https://script.google.com/macros/s/AKfycbxHbQGtAtG6cL5dJaX6ULrsaVg536-Y3rCLk1cgBAdrgRkmyLwd90hfQuaPGWrGRFvinw/exec',
        API_BASE_URL29: 'https://script.google.com/macros/s/AKfycbxO9Ju2PBCK4XEuYK2pBURrj5eHx8fuWvncELA55qcXNk5StaY0KF9mi7FaAFvoV6hG/exec',
        API_BASE_URL30: 'https://script.google.com/macros/s/AKfycbzqIoby4plskHgtvmSHavSsE_Dh0US5eIQHHsoJiMqblW2l_MVB99pet5CQT1s-ypf5/exec',
        LIFF_ID1: '2010192066-WHR9LINk',
        LIFF_ID2: '2010192066-Clmh8tm5',
        LIFF_ID3: '2010192066-hAZ33vqJ',
        LIFF_ID4: '2010192066-9hDBT7cQ',
        LIFF_ID5: '2010192066-22TxPrUo',
        LIFF_ID6: '2010192066-FLE819Mq',
        LIFF_ID7: '2010192066-MVcaDTTd',
        LIFF_ID8: '2010192066-riaP8NNq',
        LIFF_ID9: '2010192066-c3u0aIVm',
        LIFF_ID10: '2010192066-TY9SsrKz',
        LIFF_ID11: '2010192066-CGXIkmq6',
        LIFF_ID12: '2010192066-nrZusGNQ',
        LIFF_ID13: '2010192066-S6LrfW6R',
        LIFF_ID14: '2010192066-5VNBclNQ',
        LIFF_ID15: '2010192066-Dia0SYId',
        LIFF_ID16: '2010192066-7GVevlOx',
        LIFF_ID17: '2010192066-6Z4F1Sb4',
        LIFF_ID18: '2010192066-11QTgyFT',
        LIFF_ID19: '2010192066-aYraETaA',
        LIFF_ID20: '2010192066-S57mYYdG',
        LIFF_ID21: '2010192066-iWLGW0BY',
        LIFF_ID22: '2010192066-GTg0SDqd',
        LIFF_ID23: '2010192066-FrmpOSwo',
        LIFF_ID24: '2010192066-uHbRlg3V',
        LIFF_ID25: '2010192066-uGuW9JLu',
        LIFF_ID26: '2010192066-Uu9m5N6M',
        LIFF_ID27: '2010192066-1xYWntwX',
        LIFF_ID28: '2010192066-DtHOM8wT',
        LIFF_ID29: '2010192066-Ht2PyPBg',
        LIFF_ID30: '2010192066-qghR6h9M',
        FLEX_IMAGE1: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE2: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE3: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE4: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE5: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE6: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE7: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE8: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE9: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE10: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE11: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE12: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE13: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE14: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE15: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE16: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE17: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE18: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE19: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE20: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE21: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE22: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE23: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE24: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE25: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE26: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE27: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE28: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE29: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
        FLEX_IMAGE30: 'https://i.postimg.cc/QCbYThKh/flex.jpg',
    }
}

export const CURRENT_ENV = ENV.PROD;
